<template>
    <base-box border-style="dashed" background-color="gray" :clickable="true" @click="$emit('click')">
        <template slot="content">
            <g-media-object>
                <template slot="left">
                    <g-icon name="plus" class="icon-color"/>
                </template>
                <g-typography tag="p">
                    Add Product
                </g-typography>
            </g-media-object>
        </template>
    </base-box>
</template>
<script>
    export default {
        name: "ProposalProductSelectCard",
    }
</script>
<style lang="scss" scoped>
    .icon-color {
        color: $g-color-grey-5;
    }
</style>
